<template>
  <div :data-component-name="$options.name" class="div_container">
    <b-row class="m-0">
      <div
        v-if="content.titre"
        class="titre graphik_bold"
        :class="[content.image ? 'titre-image' : 'titre-no-image']"
        :style="{ 'background-color': content.couleurFondTitre }"
      >
        <b-card-img-lazy
          v-if="content.image"
          :src="jel_getFichierSrc(content.image)"
          :alt="content.titre"
          class="image ml-1"
        >
        </b-card-img-lazy>
        <span :class="[content.image ? 'ml-1' : 'ml-5']" v-html="content.titre"> </span>
      </div>
      <div class="text-container"><span class="texte" v-html="content.texte"></span></div>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'MediaImageIcoTitTxt',
  props: { content: { type: Object, required: true } },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.titre {
  color: black;
  @include ms-respond(font-size, 1);
  border-top-left-radius: ms(2);
  border-bottom-right-radius: ms(2);
  margin-left: -7%;
  margin-top: -1rem;
  padding: 1%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 3%;
  background-color: transparent;
  text-align: left;
}

.titre-no-image {
  height: ms(7);
  width: 50%;
}

.titre-image {
  height: 7rem;
  width: 70%;
}

.image {
  height: 100%;
  width: auto;
}

.div_container {
  padding-left: 5%;
  padding-right: 5%;
}

.text-container {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.texte {
  color: black;
  @include ms-respond(font-size, 0);
  font-family: 'graphik_regular';
  line-height: 1.3em;
}

@media screen and (max-width: 992px) {
  .titre {
    width: 90%;
    margin-left: -9%;
  }

  .text-container {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
